import React, { useEffect, useState } from 'react';
import ProfileBar from '../profiles/Components/ProfileBar';
import NavigateCard from './components/NavigateCard';
import Media from './components/Media';
import {
  faBuilding,
  faMapMarkerAlt,
  faPhoneAlt,
  faBus,
  faExternalLinkAlt,
  faCalendar,
  faMapMarkedAlt,
  // faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';
import CheckIn from '../assets/img/check_in.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckOut from '../assets/img/check_out.svg';
import { useShowKhelo } from '../../src/utils/HooksUtils';
// import Pad from '../assets/img/pad.svg';
import { useUserProfile } from '../profiles/queries/profileHooks';
import { useAccommodationDetails } from './queries/actHooks';
import Loader from '../components/Loader';
import { getDateInDDMMYYYY } from '../constants/DateFunctions';
// import { GoogleMap, LoadScript } from '@react-google-maps/api';
// import CardOpener from './components/CardOpener';
import ArrivalDetails from './ArrivalDetails';
import DepartureDetails from './DepartureDetails';
// import Helmet from 'react-helmet';

export default function Accommodation() {
  const { data: profile } = useUserProfile();
  const { data, isLoading } = useAccommodationDetails({ user_id: profile.message.sfa_id });
  const [center, setCenter] = useState({});
  const isKhelo = useShowKhelo();
  const accommodations = data;
  // console.log(accommodations);
  // const mapStyles = {
  //   height: '30vh',
  //   width: '100%',
  // };

  console.log(center);

  useEffect(() => {
    setCenter({
      lat: accommodations && Number(accommodations[0]?.coordinates?.split(',')[0]),
      lng: accommodations && Number(accommodations[0]?.coordinates?.split(',')[1]),
    });
  }, []);
  // console.log('data', data);
  return (
    <div>
      {/* <Helmet>
        <title>Travel & Accommodation | KIYG Haryana 2021</title>
        <meta
          name="description"
          content="Here's all the information regarding your Accommodation/Stay & Travel (Dates, Mode, etc.) at the #KIYG2021. Wish you all the very best!"
        />
        <meta property="og:title" content="Travel & Accommodation | KIYG Haryana 2021" />
        <meta
          property="og:description"
          content="Here's all the information regarding your Accommodation/Stay & Travel (Dates, Mode, etc.) at the #KIYG2021. Wish you all the very best!"
        />
      </Helmet> */}
      {!isKhelo && <ProfileBar head="Accommodation" act={true} />}
      <div className={`${!isKhelo && 'mx-6'} mb-5 flex justify-between flex-col gap-6 h-full`}>
        <div className="mt-6 max-w-full bg-white  font-roboto rounded-lg">
          <div className="w-full">
            {/* <LoadScript
              className="w-full h-30"
              googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
            >
              <GoogleMap mapContainerStyle={mapStyles} zoom={13} center={center} />
            </LoadScript> */}
          </div>
          {Array.isArray(accommodations) ? (
            <div>
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  <>
                    {!isKhelo && accommodations?.length && accommodations?.[0]?.google_map_link && (
                      <div className="md:flex md:justify-center flex md:hidden">
                        <a
                          className={`px-3 py-2.5 rounded-lg cursor-pointer font-medium mb-2 flex gap-2 bg-blue-kheloBlue text-white w-full md:w-max flex justify-center`}
                          target={'_blank'}
                          rel="noreferrer"
                          href={accommodations?.[0]?.google_map_link}
                        >
                          <FontAwesomeIcon
                            icon={faExternalLinkAlt}
                            className={'text-xs hidden md:block'}
                          />
                          <p className="font-bold text-xs text-center">View on Google Maps</p>
                          <FontAwesomeIcon
                            icon={faExternalLinkAlt}
                            className={'text-xs md:hidden'}
                          />
                        </a>{' '}
                      </div>
                    )}
                    {isKhelo && (
                      <>
                        <div className="pb-2 pt-4 shadow border border-gray-350 rounded-lg px-2 md:px-6 mb-4">
                          <div className="text-sm font-bold">Arrival Details</div>

                          {accommodations[0]?.arrival_details?.arrived ? (
                            <ArrivalDetails
                              data={[
                                {
                                  icon: faCalendar,
                                  header: 'Date',
                                  content: getDateInDDMMYYYY(
                                    accommodations?.[0]?.arrival_details?.arrival_date
                                  ),
                                  border: true,
                                },
                                {
                                  icon: faBus,
                                  header: 'Mode of Transport',
                                  content:
                                    accommodations?.[0]?.arrival_details
                                      ?.arrival_transportation_mode,
                                },
                                {
                                  icon: faMapMarkerAlt,
                                  header: 'Arrival Location',
                                  content: accommodations?.[0]?.arrival_details?.arrival_location,
                                },
                              ]}
                            />
                          ) : (
                            <span className="text-xs md:text-sm font-medium">
                              {' '}
                              {`Kindly contact your ${
                                profile?.message?.primary_role === 'coach' ||
                                profile?.message?.primary_role === 'competition_manager' ||
                                profile?.message?.primary_role === 'technical_official'
                                  ? 'SLO'
                                  : 'Chef De Mission (CDM)'
                              } for this information.`}
                            </span>
                          )}
                        </div>
                        <div className="font-medium text-blue-350 bg-blue-100 border-blue-350 border-1 px-4 py-2 my-4 text-sm md:text-base">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            className="font-medium border-b-1 border-blue-350"
                            href="/static/Arrival details.pdf"
                          >
                            Click Here
                          </a>{' '}
                          for Arrival, Hotel and Transport information
                        </div>
                      </>
                    )}
                    <div
                      className={`bg-white rounded-lg pb-2 ${
                        isKhelo ? 'px-2 md:px-6 shadow border border-gray-350 pt-4' : 'px-6'
                      }`}
                    >
                      {' '}
                      <span className="text-sm font-bold">Accommodation Details</span>
                      {isKhelo ? (
                        <div className="flex justify-between border-b pb-2">
                          <Media
                            icon={faBuilding}
                            header="My Hotel Name"
                            content={accommodations?.[0]?.hotel_name || 'To Be Assigned Shortly'}
                            border={false}
                          />
                          <div className="mt-4">
                            {isKhelo && accommodations?.[0]?.google_map_link ? (
                              <div className="md:flex md:justify-center flex hidden">
                                <a
                                  className={`px-3 py-2.5 rounded-lg cursor-pointer font-medium mb-2 flex gap-2 bg-blue-kheloBlue w-full md:w-max flex justify-center`}
                                  target={'_blank'}
                                  rel="noreferrer"
                                  href={accommodations[0]?.google_map_link}
                                >
                                  <FontAwesomeIcon
                                    icon={faExternalLinkAlt}
                                    className={'text-xs hidden md:block text-white'}
                                  />
                                  <p className="font-bold text-xs text-center text-white">
                                    View on Google Maps
                                  </p>
                                </a>{' '}
                              </div>
                            ) : null}
                            {isKhelo && accommodations[0]?.google_map_link ? (
                              <div className="md:hidden text-blue-kheloBlue">
                                <a
                                  className={``}
                                  target={'_blank'}
                                  rel="noreferrer"
                                  href={accommodations[0]?.google_map_link}
                                >
                                  <FontAwesomeIcon icon={faMapMarkedAlt} />
                                </a>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ) : (
                        <Media
                          icon={faBuilding}
                          header="My Hotel Name"
                          content={accommodations[0]?.hotel_name}
                          border={true}
                        />
                      )}
                      {false && (
                        <Media
                          icon={faMapMarkerAlt}
                          header="My Hotel Address"
                          border={true}
                          content={
                            <div className="block">
                              <span>{accommodations[0]?.address || 'To Be Assigned Shortly'}</span>
                              <p data-cy="header" className="text-xs text-deep-gray mt-2">
                                Hotel Cluster Number
                              </p>
                              <div className="flex">
                                <p
                                  data-cy="content"
                                  className="text-small font-bold text-dark-gray"
                                >
                                  {accommodations[0]?.hotel_cluster_number ||
                                    'To Be Assigned Shortly'}
                                </p>
                              </div>
                            </div>
                          }
                        />
                      )}
                      {accommodations[0]?.checkin ? (
                        <Media
                          icon={CheckIn}
                          header="My Check In Date"
                          content={`${getDateInDDMMYYYY(accommodations[0]?.checkin)}`}
                          border={true}
                        />
                      ) : null}
                      {accommodations[0]?.checkout ? (
                        <Media
                          icon={CheckOut}
                          header="My Check Out Date(Tentative)"
                          content={`${getDateInDDMMYYYY(accommodations[0]?.checkout)}`}
                          border={accommodations[0].contact}
                        />
                      ) : (
                        <Media
                          icon={CheckOut}
                          header="My Check Out Date(Tenative)"
                          content={
                            'Your Check Out date will be at 12PM (Noon), the DAY after your last match'
                          }
                          border={true}
                        />
                      )}
                      {accommodations[0]?.distance ? (
                        <Media
                          icon={faBus}
                          header="Distance From Stadium"
                          content={accommodations[0]?.distance || '-'}
                          border={true}
                        />
                      ) : null}
                      <Media
                        icon={faPhoneAlt}
                        header="Hotel Representative Contact Number"
                        border={true}
                        content={
                          <a href={`tel:${accommodations[0]?.contact}`}>
                            <span className="text-small font-bold text-dark-gray">
                              {accommodations[0]?.contact || 'To Be Assigned Shortly'}
                            </span>
                          </a>
                        }
                      />
                      {/* <Media
                        icon={faExclamationCircle}
                        header="Important Instructions"
                        content={
                          <a href="#" className="font-medium">
                            Click Here to download instructions for an easy stay
                          </a>
                        }
                      ></Media> */}
                    </div>

                    {isKhelo && (
                      <>
                        <div className="pb-2 pt-4 shadow border border-gray-350 rounded-lg px-2 md:px-6 mt-4">
                          <div className="text-sm font-bold"> Departure Details</div>
                          {accommodations[0]?.departure_details?.departed ? (
                            <DepartureDetails
                              data={[
                                {
                                  icon: faCalendar,
                                  header: 'Date',
                                  content: getDateInDDMMYYYY(
                                    accommodations[0]?.departure_details?.departure_date
                                  ),
                                  border: true,
                                },
                                {
                                  icon: faBus,
                                  header: 'Mode of Transport',
                                  content:
                                    accommodations[0]?.departure_details
                                      ?.departure_transportation_mode,
                                  border: true,
                                },
                                {
                                  icon: faMapMarkerAlt,
                                  header: 'Departure From Location',
                                  content: accommodations[0]?.departure_details?.departure_from,
                                },
                              ]}
                            />
                          ) : (
                            <span className="text-xs md:text-sm font-medium">
                              {`Kindly contact your ${
                                profile?.message?.primary_role === 'coach' ||
                                profile?.message?.primary_role === 'competition_manager' ||
                                profile?.message?.primary_role === 'technical_official'
                                  ? 'SLO'
                                  : 'Chef De Mission (CDM)'
                              } for this information.`}
                            </span>
                          )}
                        </div>
                      </>
                    )}
                  </>
                </>
              )}
            </div>
          ) : (
            <div className="py-10 w-full text-gray-700 font-md text-center">
              {!isKhelo && (accommodations?.Error || 'Attendee not Found')}
            </div>
          )}
        </div>
        {!isKhelo && (
          <NavigateCard
            dataCy="navigate"
            icon={faBus}
            header="Transport"
            navigateTo="/act/transport"
          />
        )}
      </div>
    </div>
  );
}
